import React, { Component } from 'react';
import { Navbar, } from 'react-bootstrap';
import './styles/styles.scss';

class NavbarComponent extends Component {

  render() {

    return (
      <Navbar>
        <Navbar.Brand href="/">
          <img
            alt=""
            src={require('../../img/logo_nibi_2.png')}
            className="d-inline-block align-top"
            height={40}
          />
        </Navbar.Brand>
      </Navbar>
    );
  }
}

export default NavbarComponent;
